// extracted by mini-css-extract-plugin
export var visualContainer = "visuals-module--visualContainer--dNFsG";
export var titleSection = "visuals-module--titleSection--Ghbqu";
export var imgSection = "visuals-module--imgSection--PZr1S";
export var imgName = "visuals-module--imgName--aBOYX";